import Modal from 'AWS-UI-Components-React/polaris/modal';
import React from 'react';
import { extractErrorMessage } from '../../../utilities';
import { ErrorFlash } from '../../content/error_flash';
import { getJSClient } from '../../js_client';
import { BenchmarkAdjustmentDraftTable } from './benchmark_adjustment_draft_table';
import { DownloadAdjustmentTemplate } from './download_template';
import { FileUpload } from './file_upload';

export class BenchmarkAdjustmentContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      downloadTemplateInProgress: false,
      uploadInProgress: false,
      draftItems: [],
      loading: true,
      pullDraftFailed: false,
      errorMessage: ''
    };
  }

  componentDidMount = () => {
    this.client = getJSClient();
    this.refreshDraft();
  }

  downloadTemplate = () => {
    this.setState( {downloadTemplateInProgress : true});
  }

  onDownloadDismiss = () => {
    this.setState( {downloadTemplateInProgress : false});
  }

  onUploadDismiss = (refreshDraft) => {
    this.setState( {uploadInProgress : false});
    if(refreshDraft) {
      this.refreshDraft();
    }
  }

  onUpload = () => {
    this.setState( {uploadInProgress : true});
  }

  refreshDraft = () => {
    this.setState({loading: true})
    this.client.getBenchmarkAdjustmentDraft(
      (result) => {this.onDraftPullSuccess(result)},
      (error) => {this.onDraftPullFailure(error)},
      {username: this.props.user});
  }

  onDraftPullSuccess = (result) => {
    this.setState({draftItems: result.draftItems, loading: false});
  }

  onDraftPullFailure = (error) => {
    this.setState({pullDraftFailed : true, loading: false, errorMessage: extractErrorMessage(error)});
  }

  render() {
    const {
      downloadTemplateInProgress,
      uploadInProgress,
      draftItems,
      loading,
      pullDraftFailed,
      errorMessage
    } = this.state;
    return (
      <div>
        {uploadInProgress &&
          <FileUpload
            onUploadDismiss={this.onUploadDismiss}
            user={this.props.user}
          />
        }
        {downloadTemplateInProgress && (
          <Modal
            visible={true}
            size="large"
            expandToFit={true}
            onDismiss={this.onDownloadDismiss}
            header="Download Template"
            >
              <DownloadAdjustmentTemplate
                marketplaceConfig={this.props.marketplaceConfig}
                cognosConfig={this.props.cognosConfig}
                etlConfig={this.props.etlConfig}
              />
          </Modal>
        )}
        {pullDraftFailed && <ErrorFlash type={"benchmark adjustment draft"}/>}
        {!pullDraftFailed &&
        <div className="awsui-util-container">
          <BenchmarkAdjustmentDraftTable
            draftItems={ draftItems }
            loading={ loading }
            downloadTemplate={ this.downloadTemplate }
            refreshDraft={ this.refreshDraft }
            onUpload={ this.onUpload }
            { ...this.props }
          />
        </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/benchmark_adjustment/benchmark_adjustment_container.jsx